import { createApp } from "vue";

import './../admin/utility/IPAddress'

import './integration/cf7'
import './integration/gravityforms'
import './integration/wpforms'
import './integration/fluentform'
import './integration/forminator'
import './integration/formidable'

import App from "./App.vue";

(() => {
    const app = createApp(App);
    app.mount("#formychat-widgets");

    window.addEventListener('DOMContentLoaded', () => {
        // Trigger new custom event formychat_loaded
        const event = new CustomEvent('formychat_loaded', {
            detail: { 
                formychat_loaded: true
            }
        });

        document.dispatchEvent(event);
    })

})();